import { Infinity as LucideInfinity } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const InfinityIcon = createLucideIcon(LucideInfinity);
